import * as React from "react";

import autobind from "autobind-decorator";
import classNames from "classnames";
import * as _ from "lodash";
import { connect } from "react-redux";

import { SWReactIcons } from "@similarweb/icons";
import type { IOnOffSwitchProps } from "@similarweb/ui-components";
import { OnOffSwitch } from "@similarweb/ui-components";

import { estimatedVsGaSwitchToggle } from "app/actions/commonActions";
import { estimationsVsGaUserPreferencesUpdate } from "app/actions/estimationsVsGaUserPreferencesUpdate";
import { swSettings } from "app/common/services/swSettings";
import "./GaFilter.scss";
import { GAWizardModal } from "app/components/GA-verify/GAWizardModal";
import { SwTrack } from "app/services/SwTrack";
import type { RootState, ThunkDispatchCommon } from "single-spa/store/types";

import { VerifiedDataToggleInfoTooltip } from "../../React/Tooltip/VerifiedDataToggleInfoTooltip/VerifiedDataToggleInfoTooltip";

interface IGaFilterProps extends IOnOffSwitchProps {
    isDisabled?: boolean;
    label: string;
    showGAApprovedData?: boolean;
    GaText?: string;
    SwText?: string;
    onChange?: (gaFlag: boolean) => void;
}

class GaFilter extends React.Component<IGaFilterProps, any> {
    private services;

    public static defaultProps = {
        isDisabled: false,
        GaText: "GA",
        SwText: "SW",
    };

    constructor(props: IGaFilterProps) {
        super(props);
        this.services = {
            swSettings,
        };
        this.state = {
            showGAApprovedData: false,
            isGAWizardModalOpen: false,
        };
    }

    public render() {
        const { isDisabled, className, label, showGAApprovedData } = this.props;
        const classnames = classNames("GaFilter", isDisabled ? "GaFilter--disabled" : null);
        const infoTip =
            this.services.swSettings.components.Home.resources.GaMode != "Skip" ? (
                <VerifiedDataToggleInfoTooltip onGAWizardModalOpen={this.onGAWizardModalOpen}>
                    <span>
                        <SWReactIcons
                            iconName="info"
                            className="GaInfo-icon"
                        />
                    </span>
                </VerifiedDataToggleInfoTooltip>
            ) : (
                ""
            );
        return (
            <div
                className={classnames}
                onClick={isDisabled ? _.noop : this.onClick}
            >
                <div className="GaFilter-container">
                    {label}{" "}
                    <SWReactIcons
                        iconName="ga-icon"
                        className="GaFilter-icon"
                    />
                    {infoTip}
                </div>
                <OnOffSwitch
                    className={className}
                    onClick={_.noop}
                    isSelected={showGAApprovedData}
                    isDisabled={isDisabled}
                />
                <GAWizardModal
                    isOpen={this.state.isGAWizardModalOpen}
                    onClose={this.onGAWizardModalClose}
                />
            </div>
        );
    }

    @autobind
    public onClick() {
        //Fire tracking events
        const isGASelected = !this.props.showGAApprovedData;
        const selectedText = !isGASelected ? this.props.SwText : this.props.GaText;
        SwTrack.all.trackEvent("toggle", "click", "display data/" + selectedText);
        this.props.onChange?.(isGASelected);
    }

    @autobind
    public onGAWizardModalClose() {
        this.toggleGAWizardModal(false);
    }

    @autobind
    public onGAWizardModalOpen() {
        this.toggleGAWizardModal(true);
    }

    private toggleGAWizardModal(newValue: boolean) {
        this.setState({
            ...this.state,
            isGAWizardModalOpen: newValue,
        });
    }
}

function mapStateToProps({ common }: RootState) {
    const { showGAApprovedData } = common;
    return {
        showGAApprovedData,
    };
}

function mapDispatchToProps(dispatch: ThunkDispatchCommon) {
    return {
        onChange: (checked: boolean) => {
            dispatch(estimatedVsGaSwitchToggle(checked));
            dispatch(
                estimationsVsGaUserPreferencesUpdate({
                    type: "WebsiteAnalysisVerifiedData",
                    isEnabled: checked,
                }),
            );
        },
    };
}

const connectedComponent = connect(mapStateToProps, mapDispatchToProps)(GaFilter);

export default connectedComponent;
